export default __webpack_public_path__ + "static/media/or.3b2b57ce.png";